import { MapsAPILoader } from '@agm/core';
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostListener, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EcomOlarDataService } from '@src/app/ecom-data-services/ecom-olar-data-service';
import { GoogleResult } from '@src/app/ecom-items/ecom-item-cart-checkout/google-result.model';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';
import $ from 'jquery';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { default as olarconfig } from '../../../assets/olarconfig.json';
import { EcomCookies } from '../../ecom-services/ecom-cookies';

declare const google: any;
@Component({
  selector: 'app-ecom-header',
  templateUrl: './ecom-header.component.html',
  styleUrls: ['./ecom-header.component.scss']
})
export class EcomHeaderComponent implements OnInit {
  // component class properties
  @Output() submitted: EventEmitter<any> = new EventEmitter();
  cusineList = [];
  dietaryoptions = [];
  cusineSelected: any;
  optionSelected: any;
  venue = '';
  searchValue = '';
  url = '';
  currentLocation = undefined;
  modalRef: BsModalRef;
  config = {
    animated: true,
    class: 'modal-dialog-centered modal-sm'
  };
  displayLabel = false;
  userServiceBase: UserServiceBase;
  @ViewChild('search', { static: true }) public searchElementRef: ElementRef;
  geoCoder: google.maps.Geocoder;
  latitude: number;
  longitude: number;
  zoom: number;
  addressformatted: string;
  locationExpired: Subject<boolean> = new Subject<boolean>();
  //@ViewChild('userlocation', { static: true }) userlocation: ElementRef;
  timeoutFunc: any;
  promosList = [];
  merchantPromoList = [];
  environment: any;
  overlayDisplay = false;
  configlocation = {
    animated: true,
    class: '',
    ignoreBackdropClick: true,
    keyboard: false
  };
  configlocationpopup = {
    animated: true,
    class: 'modal-location modal-dialog-centered',
    ignoreBackdropClick: true,
    keyboard: false
  };
  @ViewChild('userlocationpopup', { static: true }) userlocationpopup: ElementRef;
  @ViewChild("placesRef", { static: true }) placesRef: GooglePlaceDirective;
  locationSearchError = false;
  options = {
    types: [],
    componentRestrictions: { country: 'my' }
  };
  address: Address;
  addresschanged = false;
  itemsPerSlide = 2;
  singleSlideOffset = true;
  noWrap = false;
  olarmePromoList = [];
  defaultImage = './assets/images/homedefault.jpeg';
  filtersSelected = false;
  filtersSelectedCount = 0;
  FiltersList: any = [];
  companyPromotion = '';
  loggedIn = false;
  username = '';
  colors = ['#1d3259', '#d73e71', '#ff9e17', '#24678c', '#98948f'];
  random = 0;
  private subject: Subject<string> = new Subject();
  filterArraySelectedData = [];
  filterArrayData = [];
  googlePlaceSelected = '';
  searchTerm: string;
  googlePlacesResults: GoogleResult[] = [];
  tempResponse: any;
  googlePlace: any;
  warningMessage = '';
  userhomeAddress = '';
  usertoken = false;
  userSavedAddressList = [];
  locCount = 0;
  // constructor to inject the class objects
  constructor(public ecomOlarDataService: EcomOlarDataService, public router: Router, public ecomservice: EComService, private webstorage: EComWebStorage, private mapsAPILoader: MapsAPILoader, public cookie: EcomCookies,
    private sessionSt: SessionStorageService, private localSt: LocalStorageService,
    private ngZone: NgZone, public modalService: BsModalService, public activatedRoute: ActivatedRoute, public location: Location,
    private settingService: EcomSettingService) {
    this.environment = olarconfig.Environment;
    this.olarmePromoList = [];
    this.olarmePromoList.push('assets/images/promos/Banner1.png');
    this.olarmePromoList.push('assets/images/promos/Banner2.png');
    this.olarmePromoList.push('assets/images/promos/Banner3.png');
    this.olarmePromoList.push('assets/images/promos/Banner4.png');
    this.olarmePromoList.push('assets/images/promos/Banner5.png');
    this.olarmePromoList.push('assets/images/promos/Banner6.png');
    this.olarmePromoList.push('assets/images/promos/Banner7.png');
    this.olarmePromoList.push('assets/images/promos/Banner8.png');
    this.olarmePromoList.push('assets/images/promos/Banner9.png');
    this.olarmePromoList.push('assets/images/promos/Banner10.png');
    this.olarmePromoList.push('assets/images/promos/Banner11.png');

    this.settingService.currentUserServiceBase.subscribe(userServiceBase => {
      this.userServiceBase = userServiceBase;
    });
  }

  onClearAddressClick() {
    this.currentLocation = undefined;
    this.googlePlacesResults = [];
    this.setUserAddressList(this.userSavedAddressList);
  }

  onLocationChange(data, from = '') {
    if (data && data.place_id) {
      this.userhomeAddress = data.description;
      this.cookie.cookie_address_place_id = data.place_id;
      if (data.place_id) {
        let request = {
          "placeId": data.place_id
        }
        const map = new google.maps.Map(document.getElementById("map"), {
          center: {
            lat: 2.198470,
            lng: 102.239372
          },
          zoom: 14
        });
        const mapPlaceService = new google.maps.places.PlacesService(map);
        mapPlaceService.getDetails(request, (place, status) => {
          this.setPlaceDetails(place, from);
        });
      }
    } else {
      //check if address exist in saved address details
      if (data && data.description) {
        let address = this.userSavedAddressList.find(obj => {
          return obj.ooca_address === data.description;
        });
        if (address) {
          // get the latlng from saved address  list
          const latlng = new google.maps.LatLng(Number(address.ooca_latlang.split(',')[0]), Number(address.ooca_latlang.split(',')[1]));
          const geoCoder = new google.maps.Geocoder().geocode({ location: latlng })
            .then((response) => {
              if (response) {
                // find the first place which is less 50chars of placeid
                let place = response.results.find(obj => {
                  return obj.place_id.length < 50;
                });
                if (place) {
                  this.setPlaceDetails(place);
                }
              }
            });
        }
      }
    }
  }


  setPlaceDetails(place, from = '') {

    //verify result
    if (place.geometry === undefined || place.geometry === null) {
      return;
    }
    this.address = place;
    let address = place.formatted_address;
    if (!address.includes(place.name)) {
      address = place.name + ', ' + place.formatted_address;
    }
    //this.webstorage.localSt_current_location = address;
    this.cookie.cookie_user_location = address;

    const userLatlng = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    };
    //this.webstorage.localSt_latlng = userLatlng.lat + ',' + userLatlng.lng;
    this.cookie.cookie_latlng = userLatlng.lat + ',' + userLatlng.lng;

    const header = {
      type: 'userlocation',
      data: userLatlng
    };
    const countrycode = place.address_components.find(obj => {
      return obj.types[0] === 'country'
    });
    if (countrycode) {
      //this.webstorage.localSt_user_country_code = countrycode.short_name;
      this.cookie.cookie_country_code = countrycode.short_name;
    }
    if (from !== 'home') {
      this.webstorage.sessionSt_page_reload = true;
      this.submitted.emit(header);
    }
    const trackingInput = {
      gat_ipaddress: this.webstorage.localSt_ip,
      gat_type: 'PLACE CHANGE API'
    };
    this.ecomservice.googleApiTrack(trackingInput);
  }

  getData() {
    // this.placePredictionService.currentData.subscribe((response: GoogleResult[]) => {
    //   this.googlePlacesResults = [];
    //   if (response) {
    //     this.warningMessage = '';
    //     this.googlePlacesResults = response;
    //   } else {
    //     this.currentLocation = undefined;
    //     this.warningMessage = 'Searched location not found';
    //   }
    // });
  }

  textboxKeyup(event) {
    let value = event.target.value;
    if (value) {
      if (value.length === 0) {
        if (this.userSavedAddressList.length > 0) {
          this.googlePlacesResults = [];
          this.setUserAddressList(this.userSavedAddressList);
        }
      } else if (value.length >= 3) {
        this.onSearch(value);
      }
    } else {
      if (this.userSavedAddressList.length > 0) {
        this.googlePlacesResults = [];
        this.setUserAddressList(this.userSavedAddressList);
      }
    }
  }

  placesKeyUp(event) {
    this.currentLocation = undefined;
    let value = event.target.value;
    if (value) {
      if (value.length === 0) {
        if (this.userSavedAddressList.length > 0) {
          this.googlePlacesResults = [];
          this.setUserAddressList(this.userSavedAddressList);
        }
      } else if (value.length >= 3) {
        this.onSearch(value);
      }
    } else {
      if (this.userSavedAddressList.length > 0) {
        this.googlePlacesResults = [];
        this.setUserAddressList(this.userSavedAddressList);
      }
    }
  }

  customSearchFn(term: string, item: any) {
    return true;
  }

  onSearch(term: string) {
    this.searchTerm = term;
    if (this.searchTerm === '') {
      return;
    }
    //this.placePredictionService.getPlacePredictions(term);
  }

  getAddressListDropdownData() {
    this.googlePlacesResults = [];
    let tempAddressList = [];
    // check exist before pushing it
    let isExist = this.googlePlacesResults.find(obj => {
      return obj.place_id === this.cookie.cookie_address_place_id;
    });
    if (isExist === undefined) {
      let googlePlaceSelected = {
        description: this.cookie.cookie_user_location,
        id: '',
        matched_substrings: [],
        place_id: this.cookie.cookie_address_place_id,
        reference: '',
        structured_formatting: null,
        terms: [],
        types: []
      };
      tempAddressList.push(googlePlaceSelected);
    }
    this.googlePlacesResults = tempAddressList;
    this.getSavedAddress();
  }

  getSavedAddress() {
    let input = {
      ooc_customer_mobile: '',
      ooc_country_dial_code: ''
    }
    if (this.usertoken) {
      input.ooc_customer_mobile = this.cookie.cookie_user_phone;
      input.ooc_country_dial_code = this.cookie.cookie_user_country_code;

      this.ecomservice.httpPost(EcomNetworkUtils.POST_GET_USER_ADDRESS, input, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          this.userSavedAddressList = response.listValues;
          this.setUserAddressList(response.listValues);
        }
      });
    }
  }


  setUserAddressList(listValue) {
    if (listValue) {
      let tempAddressList = [];
      // check exist before pushing it
      let isExist = this.googlePlacesResults.find(obj => {
        return obj.place_id === this.cookie.cookie_address_place_id;
      });
      if (isExist === undefined) {
        let googlePlaceSelected = {
          description: this.cookie.cookie_user_location,
          id: '',
          matched_substrings: [],
          place_id: this.cookie.cookie_address_place_id,
          reference: '',
          structured_formatting: null,
          terms: [],
          types: []
        };
        tempAddressList.push(googlePlaceSelected);
      } else {
        tempAddressList.push(isExist);
      }
      listValue.forEach(element => {
        // check exist before pushing it
        let isExist = tempAddressList.find(obj => {
          return obj.place_id === element.ooca_place_id;
        });
        if (isExist === undefined) {
          let googlePlaceSelected = {
            description: element.ooca_address,
            id: '',
            matched_substrings: [],
            place_id: element.ooca_place_id,
            reference: '',
            structured_formatting: null,
            terms: [],
            types: []
          };
          tempAddressList.push(googlePlaceSelected);
        }
      });
      this.googlePlacesResults = tempAddressList;

    }
  }

  // component initialize and load the required data
  ngOnInit() {
    this.resetLocalStorage();
    this.getData();
    console.log('ngOnInit');
    this.usertoken = (this.cookie.cookie_authtoken && this.webstorage.localSt_user_id) ? true : false;
    this.getAddressListDropdownData();
    if (this.cookie.cookie_user_location) {
      this.userhomeAddress = this.cookie.cookie_user_location;
      this.currentLocation = this.cookie.cookie_address_place_id ? this.cookie.cookie_address_place_id : undefined;
    }
    let temp = this;
    setTimeout(function () {
      temp.setCurrentLocationFromCookie()
    }, 1000);
    this.cookie.deleteCheckoutCookies();

    this.webstorage.sessionSt_is_session_valid = 'YES';
    this.ecomOlarDataService.currentfiltersArraySelected.subscribe(list => {
      this.filterArraySelectedData = list;
    }
    );
    this.ecomOlarDataService.currentfiltersArray.subscribe(list => {
      this.filterArrayData = list;
    }
    );
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchTextValue => {
      this.emitSearchEvent(searchTextValue);
    });
    // remove the error message
    this.webstorage.sessionSt_message_closed_today = false;
    this.webstorage.sessionSt_message_too_far = false;
    this.webstorage.sessionSt_message_delivery_error = false;
    this.webstorage.sessionSt_message_collection_error = false;
    this.webstorage.sessionSt_message_dinein_error = false;

    this.loggedIn = this.webstorage.localSt_user_id ? true : false;
    this.sessionSt.observe('sessionst_merchant_promo')
      .subscribe((value) => this.setPromos());

    this.username = this.webstorage.localSt_name;


    this.filtersSelectedCount = 0;
    if (this.filterArraySelectedData.length > 0) {
      for (let filtername of this.filterArraySelectedData) {
        let selected = false;
        for (let option of filtername.values) {
          if (option.optionSelected) {
            this.filtersSelectedCount = this.filtersSelectedCount + 1;
          }
        }
      }
    } else {
      this.filtersSelectedCount = 0;
    }
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['restaurant']) {
        this.location.replaceState(this.location.path().split('?')[0], '');
        this.companyPromotion = params['restaurant'];
        this.webstorage.sessionSt_promotion_company = this.companyPromotion;
      }
      this.getMyIp();
    });

  }

  getMyIp() {
    this.ecomservice.httpGetOuterResponseHeader(EcomNetworkUtils.GET_IP_ADDRESS + this.ecomservice.GetOlarConfigValue('ipgeolocation_key'), '', true).subscribe((response: HttpResponse<any>) => {
      if (response.status === 200) {
        console.log(response.body);
        this.webstorage.localSt_ip = response.body.ip;
        this.webstorage.localSt_latlng = response.body.latitude + ',' + response.body.longitude;
        this.webstorage.localSt_countrycode = response.body.country_code2;
        this.LoadPage();
      }
    });
  }

  setPromotionCompany(value) {
    if (value) {
      let merchantIndex = -1;
      let merchant = this.merchantPromoList.find((obj, index) => {
        merchantIndex = index;
        return obj.oocls_company_name.toLocaleLowerCase() === value.toLocaleLowerCase();
      });
      if (merchant !== undefined) {
        // remove the item from array and place at 0th position
        this.merchantPromoList.splice(merchantIndex, 1);
        merchant.blink = true;
        this.merchantPromoList.splice(0, 0, merchant);
      }
    }
  }


  setPromos() {
    this.merchantPromoList = [];
    let promoList = this.webstorage.sessionSt_merchant_promos;
    if (promoList) {
      for (let i = 0; i < promoList.length; i++) {
        if (promoList[i].oocls_slider_publish && promoList[i].display_promotion) {
          this.merchantPromoList.push(promoList[i]);
        }
      }
    }
    this.setPromotionCompany(this.webstorage.sessionSt_promotion_company);
  }


  // Method to handle the location click event
  onLocationClickheader(location) {
    this.webstorage.sessionSt_qr_paymentmode = undefined;
    this.webstorage.sessionSt_qrcode_type = undefined;
    this.webstorage.sessionSt_qr_code_scanned = undefined;
    this.webstorage.sessionSt_category_selected = undefined;
    this.webstorage.sessionSt_item_selected = undefined;
    this.webstorage.sessionSt_searched_item = undefined;
    this.webstorage.sessionSt_active_category = undefined;
    this.webstorage.sessionSt_scanned_dinein_table = false;
    this.webstorage.sessionSt_scanned_entry = false;
    this.webstorage.sessionSt_location_selected = location;
    this.webstorage.sessionSt_frompage = 'home';
    //this.webstorage.sessionSt_topage = 'store';
    this.webstorage.sessionSt_topage = 'items';
    this.webstorage.sessionSt_store_open_for_orders = location.oocls_order_open ? 'YES' : 'NO';
    this.webstorage.sessionSt_company_clicked = location.oocls_company_name.trim().replace(/\s+/g, '-').toLowerCase();
    this.router.navigate([this.webstorage.sessionSt_topage, this.webstorage.sessionSt_company_clicked]);
  }


  pickMyLocation() {
    this.addresschanged = false;
    this.random = this.getRandomDifferent(this.colors, this.random);
    this.modalRef = this.modalService.show(this.userlocationpopup, this.configlocationpopup);
  }



  LoadPage() {
    this.setPromos();
    //if (!this.webstorage.localSt_current_location) {
    //  this.modalRef = this.modalService.show(this.userlocationpopup, this.configlocationpopup);
    //}
    if (!this.cookie.cookie_user_location) {
      this.random = this.getRandomDifferent(this.colors);
      this.modalRef = this.modalService.show(this.userlocationpopup, this.configlocationpopup);
    }
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.initPage();
        }
      });
    } else {
      this.initPage();
    }
  }

  setCurrentLocationFromCookie() {
    this.currentLocation = this.cookie.cookie_address_place_id ? this.cookie.cookie_address_place_id : undefined;
  }

  initPage() {

    //this.googleMapLocationAutocomplete();
    const pageurl = this.router.url;
    if (this.router.url.indexOf('home') != -1) {
      this.url = '/home'
    } else if (this.router.url.indexOf('stores') != -1) {
      this.url = '/stores'
    } else if (this.router.url.indexOf('support') != -1) {
      this.url = '/support'
    }
    //this.url = this.router.url;
    this.getDietaryCusines();
    this.sessionSt.observe('sessionSt_settings_locations')
      .subscribe((value) => this.displayLabel = true);
    this.localSt.observe('localst_user_countrycode')
      .subscribe((value) => this.GetOlarDiscounts());
    if (!this.webstorage.sessionSt_olar_discounts) {
      this.GetOlarDiscounts();
    } else {
      this.promosList = this.webstorage.sessionSt_olar_discounts;
      if (this.promosList.length === 0) {
        this.GetOlarDiscounts();
      }
    }
  }

  GetOlarDiscounts() {
    //let countryCode = this.webstorage.localSt_user_country_code;
    let countryCode = this.cookie.cookie_country_code;
    this.ecomservice.httpGet(EcomNetworkUtils.GET_OLAR_DISCOUNTS + "?countryCode=" + countryCode, '', true).subscribe((response) => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          this.webstorage.sessionSt_olar_discounts = response.listValues;
          this.promosList = this.webstorage.sessionSt_olar_discounts;
        } else {
          // network error
        }
      }

    });
  }

  // Method to check the cookie is enabled or not
  checkCookie() {
    var cookieEnabled = navigator.cookieEnabled;
    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") != -1;
    }
    return cookieEnabled;
  }


  // Method to get the user location from google api
  getUserLocationFromGoogle(lat, lng) {
    this.ecomservice.httpGetOuterResponseHeader(EcomNetworkUtils.G_POST_LOCATION_ADDRESS + '?key=' + this.ecomservice.GetOlarConfigValue('googleapi_googlemapsapikey') + '&latlng=' + lat + ',' + lng, '', true).subscribe((response: HttpResponse<any>) => {
      if (response.status === 200) {
        if (response.body.results && response.body.results.length > 0) {
          this.userServiceBase.userAddress = response.body.results[0].formatted_address;
          this.userServiceBase.userMapAddress = response.body.results[0].formatted_address;
          const postalcode = response.body.results[0].address_components.find(obj => {
            return obj.types[0] === 'postal_code'
          });
          if (postalcode !== undefined) {
            this.userServiceBase.userPostalCode = postalcode.long_name;
          }
          const city = response.body.results[0].address_components.find(obj => {
            return obj.types[0] === 'locality'
          });
          if (city !== undefined) {
            this.userServiceBase.userCity = city.long_name;
          }
          const countrycode = response.body.results[0].address_components.find(obj => {
            return obj.types[0] === 'country'
          });
          if (countrycode) {
            //this.webstorage.localSt_user_country_code = countrycode.short_name;
            this.cookie.cookie_country_code = countrycode.short_name;
          }
          //this.webstorage.localSt_current_location = response.body.results[0].formatted_address;


          this.currentLocation = response.body.results[0].formatted_address;
          this.cookie.cookie_user_location = response.body.results[0].formatted_address;
          const input = {
            device_id: this.webstorage.localSt_ip,
            //lat_lng: this.webstorage.localSt_latlng
            lat_lng: this.cookie.cookie_latlng
          }
          //this.handShakeBeforeLogin(input);
          this.webstorage.localSt_user_service_request = this.userServiceBase;
        }
      } else {
      }
    });
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }

  // Method to get the current location
  private getCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        //this.webstorage.localSt_latlng = this.latitude + ',' + this.longitude;
        this.cookie.cookie_latlng = this.latitude + ',' + this.longitude;
        this.webstorage.sessionSt_page_reload = true;
        this.getUserLocationFromGoogle(this.latitude, this.longitude);
      });
    }
  }

  // Method to get the address
  getAddress(latitude, longitude) {
    if (this.geoCoder) {
      this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.zoom = 12;
            this.addressformatted = results[0].formatted_address;
          } else {
            //window.alert('No results found');
          }
        } else {
          //window.alert('Geocoder failed due to: ' + status);
        }
      });
    }
  }

  // Method to get the address auto complete 
  googleMapLocationAutocomplete() {
    //set current position
    this.mapsAPILoader.load().then(() => {
      //this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
      let defaultBounds: any;
      //if (this.webstorage.localSt_latlng) {
      //  defaultBounds = new google.maps.LatLngBounds(
      //    new google.maps.LatLng(this.webstorage.localSt_latlng.split(',')[0], this.webstorage.localSt_latlng.split(',')[1]));
      //}
      if (this.cookie.cookie_latlng) {
        defaultBounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(this.cookie.cookie_latlng.split(',')[0], this.cookie.cookie_latlng.split(',')[1]));
      }
      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement,
        {
          //componentRestrictions: { country: ['my', 'au', 'sg', 'in'] },
          componentRestrictions: { country: ['my'] },
          bounds: defaultBounds
          // types: [this.adressType]  // 'establishment' / 'address' / 'geocode'
        });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            // Do anything you like with what was entered in the ac field.
            return;
          }
          let address = place.formatted_address;
          if (!address.includes(place.name)) {
            address = place.name + ', ' + place.formatted_address;
          }
          //this.webstorage.localSt_current_location = address;
          this.cookie.cookie_user_location = address;
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          const userLatlng = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };
          //this.webstorage.localSt_latlng = userLatlng.lat + ',' + userLatlng.lng;
          this.cookie.cookie_latlng = userLatlng.lat + ',' + userLatlng.lng;
          this.webstorage.sessionSt_page_reload = true;
          const header = {
            type: 'userlocation',
            data: userLatlng
          };
          const countrycode = place.address_components.find(obj => {
            return obj.types[0] === 'country'
          });
          if (countrycode) {
            //this.webstorage.localSt_user_country_code = countrycode.short_name;
            this.cookie.cookie_country_code = countrycode.short_name;
          }
          this.submitted.emit(header);
          const trackingInput = {
            gat_ipaddress: this.webstorage.localSt_ip,
            gat_type: 'PLACE CHANGE API'
          };
          this.ecomservice.googleApiTrack(trackingInput);
        });
      });
    });
  }


  // Method to nagivate the request
  navigate() {
    this.router.navigate(['stores']);
  }

  // Method to handle the key events
  onKey(event: any) {
    //key code
    this.searchValue = event.target.value;

    // if (event.keyCode !== 8 && event.keyCode !== 46) {
    //   if (this.searchValue.length >= 3) {
    //     this.submitted.emit(header);
    //   }
    //   if (this.searchValue.length === 0) {
    //     this.submitted.emit(header);
    //   }
    // }
    this.subject.next(this.searchValue);
    //this.emitSearchEvent(header);
  }

  emitSearchEvent(searchText) {
    const header = {
      type: 'venue',
      data: searchText
    }
    if (this.searchValue.length >= 3) {
      this.submitted.emit(header);
    }
    if (this.searchValue.length === 0) {
      this.submitted.emit(header);
    }
  }

  // Method to handle the cusine change event
  onCusineChange(event) {
    if (event) {
      const header = {
        type: 'cusine',
        data: event.dc_name
      }
      this.submitted.emit(header);
    }
    // if (event) {
    //   let name = '';
    //   event.forEach(element => {
    //     name += element.dc_name + ',';
    //   });
    //   name = name.substring(0, name.length - 1)
    //   const header = {
    //     type: 'cusine',
    //     data: name
    //   }
    //   this.submitted.emit(header);
    // }
  }

  // Method to handle the option change event
  onOptionsChange(event) {
    // single select
    if (event) {
      const header = {
        type: 'option',
        data: event.dc_name
      }
      this.submitted.emit(header);
    }
    // for multiselect
    // if (event) {
    //   let name = '';
    //   event.forEach(element => {
    //     name += element.dc_name + ',';
    //   });
    //   name = name.substring(0, name.length - 1)
    //   const header = {
    //     type: 'option',
    //     data: name
    //   }

    //   this.submitted.emit(header);
    // }
  }

  // Method to navigate
  onNavigate() {
    window.open(this.ecomservice.GetOlarConfigValue('merchantmate'), "_blank");
  }

  // Method to clear the selection
  clear(type) {
    let header = {
      type: 'cusine',
      data: ''
    }
    if (type === 'CUSINE') {
      header = {
        type: 'cusine',
        data: ''
      }
    } else {
      header = {
        type: 'option',
        data: ''
      }
    }
    this.submitted.emit(header);
  }

  // Method to fixe the location header at home page
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    // if (this.url === '/home') {
    //   if (window.pageYOffset > 10) {
    //     let element = document.getElementById('navbar');
    //     element.classList.add('location-sticky');
    //   } else {
    //     let element = document.getElementById('navbar');
    //     element.classList.remove('location-sticky');
    //   }
    // }
    if (this.url === '/home') {
      if (window.pageYOffset > 10) {
        let element = document.getElementById('navbar');
        if (element) {
          element.classList.add('location-sticky');
        }
      } else {
        let element = document.getElementById('navbar');
        if (element) {
          element.classList.remove('location-sticky');
        }
      }
    } else if (this.url === '/stores') {
      if (window.pageYOffset > 10) {
        let element = document.getElementById('navbar-stores');
        if (element) {
          element.classList.add('location-sticky');
          element.classList.add('margin-top-0');
        }

        element = document.getElementById('navbar');
        if (element) {
          element.classList.add('location-sticky');
        }
      } else {
        let element = document.getElementById('navbar-stores');
        if (element) {
          element.classList.remove('location-sticky');
          element.classList.remove('margin-top-0');
        }

        element = document.getElementById('navbar');
        if (element) {
          element.classList.remove('location-sticky');
        }
      }
    }
  }

  overlayOpen() {
    this.overlayDisplay = true;
  }

  closeOverlay() {
    this.overlayDisplay = false;
  }

  merchantportalClick() {
    window.open(this.ecomservice.GetOlarConfigValue('merchantmate'), "_blank");
  }

  listYourRestaurantClick() {
    window.open(this.ecomservice.GetOlarConfigValue('merchantmate'), "_blank");
  }

  onSignInClick() {
    this.webstorage.sessionSt_frompage = 'home';
    this.webstorage.sessionSt_topage = 'login';
    this.router.navigate(['login']);
  }

  suppotCenter() {
    this.router.navigate(['support']);
  }

  onCloseSupportClick() {
    this.router.navigate(['home']);
  }

  onFindFoodClick() {
    this.locationSearchError = false;
    //if (!this.webstorage.localSt_current_location || !this.currentLocation) {
    if (!this.cookie.cookie_user_location || !this.currentLocation) {
      this.locationSearchError = true;
    } else {
      //$('.modal').css({"display": "none"});
      this.modalRef.hide();
    }
    this.addresschanged = true;
    let locationdetails = {
      'address': this.address,
      'changed': this.addresschanged,
      'type': 'locationchange'
    };
    this.webstorage.localSt_YourVersion = olarconfig.ReleaseVersion;
    this.submitted.emit(locationdetails);
  }

  handleAddressChange(address: Address) {
    this.locationSearchError = false;
    this.addresschanged = true;
    this.address = address;
    this.currentLocation = address.name + ',' + address.formatted_address;
    // this.webstorage.localSt_current_location = this.currentLocation;
    this.cookie.cookie_user_location = this.currentLocation;
    const trackingInput = {
      gat_ipaddress: this.webstorage.localSt_ip,
      gat_type: 'PLACE CHANGE API'
    };
    this.ecomservice.googleApiTrack(trackingInput);
  }

  onMoreClick() {
    this.webstorage.sessionSt_frompage = 'home';
    this.webstorage.sessionSt_topage = 'filters';
    this.router.navigate([this.webstorage.sessionSt_topage]);
  }

  onFilterClick() {
    this.webstorage.sessionSt_frompage = 'stores';
    this.webstorage.sessionSt_topage = 'filters';
    this.router.navigate([this.webstorage.sessionSt_topage]);
  }

  onClearClick() {
    const header = {
      type: 'venue',
      data: ''
    }
    this.venue = '';
    this.submitted.emit(header);
  }

  onOptionChoose(option) {

  }

  // Method to get the dietary cusines
  getDietaryCusines() {

    if (this.filterArrayData.length == 0) {
      this.ecomservice.httpGet(EcomNetworkUtils.GET_DIETARY_CUSINES, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.status === 200) {
            this.ecomOlarDataService.updatefiltersArraySource(response.listValues);
            this.loadDietaryCusines();
          }
        }
      });
    } else {
      this.loadDietaryCusines();
    }
  }

  // Method load the dietary cusines to list
  loadDietaryCusines() {
    this.FiltersList = [];
    this.ecomservice.loadingPage.loading = false;
    if (this.filterArraySelectedData.length > 0) {
      this.FiltersList = this.filterArraySelectedData;
    } else {
      const dietarycusineslist = this.filterArrayData;
      // Dietary options
      let dietaryOptions = {
        name: 'Dietary Options',
        values: [],
        collapsed: false
      };
      dietarycusineslist.forEach((element, i) => {
        if (element.dc_type === 'DIETARY') {
          element.optionName = element.dc_name;
          element.optionSelected = false;
          element.imgsource = '';
          dietaryOptions.values.push(element);
        }
      });
      this.FiltersList.push(dietaryOptions);
      //cuisens option
      let cuisineOptions = {
        name: 'Cuisine',
        values: [],
        collapsed: true
      };
      dietarycusineslist.forEach((element, i) => {
        if (element.dc_type === 'CUISINE') {
          let str = element.dc_name.replace('/', '');
          element.imgsource = 'assets/images/cusines/' + str + '.jpeg';
          element.optionName = element.dc_name;
          element.optionSelected = false;
          cuisineOptions.values.push(element);
        }
      });
      this.FiltersList.push(cuisineOptions);
      //Dishes option
      let dishesOptions = {
        name: 'Dishes',
        values: [],
        collapsed: true,
      };
      dietarycusineslist.forEach((element, i) => {
        if (element.dc_type === 'DISHES') {
          let str = element.dc_name.replace('/', '');
          element.imgsource = '';
          element.optionName = element.dc_name;
          element.optionSelected = false;
          dishesOptions.values.push(element);
        }
      });
      this.FiltersList.push(dishesOptions);
    }
  }

  onFavoriteClick(type) {
    if (this.filterArraySelectedData.length > 0) {
      this.FiltersList = this.filterArraySelectedData;
    }
    switch (type) {
      case 'PIZZA':
        this.FavouriteClickHandler('Cuisine', 'Pizza');
        break;
      case 'BAKERY':
        this.FavouriteClickHandler('Cuisine', 'Bakery');
        break;
      case 'VEGETARIAN':
        this.FavouriteClickHandler('Dietary Options', 'VEGETARIAN');
        break;
      case 'HALAL':
        this.FavouriteClickHandler('Dietary Options', 'HALAL');
        break;
      case 'ALL':
        this.FavouriteClickHandler('ALL', '');
        break;
      case 'INDIAN':
        this.FavouriteClickHandler('Cuisine', 'Indian');
        break;
      case 'CHINESE':
        this.FavouriteClickHandler('Cuisine', 'Chinese');
        break;
      case 'LOCAL':
        this.FavouriteClickHandler('Cuisine', 'Malaysian');
        break;
      case 'COLLECTION':
        //this.FavouriteClickHandler('DIETARY','HALAL');
        break;
    }
    this.router.navigate(['stores']);
  }

  FavouriteClickHandler(type, optionname) {
    // clear the previous selected options
    this.FiltersList.forEach(element => {
      element.values.forEach(option => {
        option.optionSelected = false;
      });
    });
    if (type !== 'ALL') {
      let filterIndex = -1;
      this.FiltersList.find((obj, index) => {
        filterIndex = index;
        return obj.name === type;
      });
      let optionIndex = -1;
      let option = this.FiltersList[filterIndex].values.find((obj, ind) => {
        optionIndex = ind;
        return obj.optionName === optionname;
      });
      if (option) {
        this.FiltersList[filterIndex].values[optionIndex].optionSelected = true;
      }
      this.ecomOlarDataService.updatefiltersArraySelectedSource(this.FiltersList);
    }
  }

  getRandomDifferent(arr, last = undefined) {
    if (arr.length === 0) {
      return;
    } else if (arr.length === 1) {
      return 0;
    } else {
      let num = 0;
      do {
        num = Math.floor(Math.random() * arr.length);
      } while (arr[num] === last);
      return num;
    }
  }

  onClickSeachIcon() {
    $(".googleLocationSearch").focus();
  }

  resetLocalStorage() {
    this.webstorage.clear('LOCAL', 'sessionst_qrcodescanned');
    this.webstorage.clear('LOCAL', 'sessionst_qrcode_type');
  }

  contactUsEventEmitter(event) {
    this.overlayDisplay = false;
  }

}
